import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Row, Tabs, Tab} from 'react-bootstrap'
import ProfileInfo from './ProfileInfo'

import './Layout/Profile.css'

class ProfileScreen extends Component {
  constructor (props) {
    super(props)
    this.state = {
      user: props.user
    }
  }

  componentWillReceiveProps (nextProps) {
    this.setState({user: nextProps.user})
  }

  render () {
    const { user } = this.state
    return (
      <Row className="Box">
        {user && <Tabs defaultActiveKey={1} id="uncontrolled-tab-example">
          <Tab eventKey={1} title="اطلاعات"><ProfileInfo info={user} /></Tab>
        </Tabs>}
      </Row>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.currentUser
  }
}

export default connect(mapStateToProps)(ProfileScreen)



// WEBPACK FOOTER //
// ./src/components/User/Profile/ProfileScreen.js